import Footer from "../../components/Footer";
import Header from "../../components/Header";
import EVCSMaintenance from "../../components/Service/Subservice/maintence-of-evcs";
import SubServiceBanner from "../../components/Service/Subservice/subservicebanner";

export default function EVCSMaintenancePage() {
    return (
        <>
            <Header/>
            <SubServiceBanner title={"EVCS Operations & Maintenance"}/>
            <EVCSMaintenance/>
            <Footer/>
        </>
    )
}